import * as Cookies from 'js-cookie';
import { remove } from '../helpers';

const getFavouritesList = () => {
  const storedFavourites = Cookies.get('storedFavourites');

  if (storedFavourites) {
    return JSON.parse(storedFavourites);
  }

  return [];
};

const saveFavouritesList = (favouritesList) => {
  if (favouritesList.length < 1) {
    Cookies.remove('storedFavourites', {
      path: '/',
    });

    return;
  }

  Cookies.set('storedFavourites', JSON.stringify(favouritesList), {
    path: '/',
    expires: 30,
    sameSite: 'Lax',
  });
};

const setCounter = (list) => {
  const counter = document.querySelector('.fav-count');
  const count = list.length;

  if (typeof counter !== 'undefined' && counter !== null) {
    counter.innerHTML = `${count}`;
  } else if (count >= 1) {
    const elements = document.querySelectorAll('.saved-homes');

    elements.forEach((element) => {
      if (element.classList.contains('saved-homes--mobile')) {
        element.insertAdjacentHTML(
          'beforeend',
          `<span class="fav-count">(${count})</span>`
        );
      } else if (element.firstElementChild) {
        element.firstElementChild.insertAdjacentHTML(
          'beforeend',
          `<span class="fav-count">${count}</span>`
        );
      }
    });
  }
};

const setUI = (list) => {
  const homes = document.querySelectorAll('.favouriteBtn');

  homes.forEach((home) => {
    if (list.includes(home.dataset.id)) {
      home.classList.add('favouriteBtn--active');
    } else {
      home.classList.remove('favouriteBtn--active');
    }
  });
};

const toggleFavourite = (plotId) => {
  let favouritesList = getFavouritesList();
  const uuid = String(plotId);

  if (!favouritesList.includes(uuid)) {
    favouritesList = [...favouritesList, uuid];
  } else {
    favouritesList = remove(favouritesList, uuid);
  }

  saveFavouritesList(favouritesList);
  setUI(favouritesList);
  setCounter(favouritesList);

  const favouritesArea = document.querySelector('.favourites-area');

  if (typeof favouritesArea !== 'undefined' && favouritesArea !== null) {
    location.reload();
  }
};

function Favourites() {
  const favouritesBtns = document.querySelectorAll('.favouriteBtn');
  const favouritesList = getFavouritesList();

  setUI(favouritesList);
  setCounter(favouritesList);

  favouritesBtns.forEach((btn) => {
    if (btn.dataset.favouritesInitialised === 'true') {
      return;
    }

    btn.dataset.favouritesInitialised = 'true';

    btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      toggleFavourite(btn.dataset.id);
    });
  });
}

export { getFavouritesList, toggleFavourite };

export default Favourites;
